import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import RedButton from 'components/buttons/RedButton';
import { Text1 } from 'components/typography/Texts';

const Container = styled.div`
  width: 100%;
  align-items: center;
  justify-content: center;
`;

const Header = styled(Text1)`
  text-align: left;
  margin-bottom: 10px;
`;

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
`;

interface Props {
  onConfirmed: () => void;
  onCanceled: () => void;
}

const ButtonsSection = ({ onConfirmed, onCanceled }: Props) => {
  const { t } = useTranslation('checkout');

  return (
    <Container>
      <Header>{t('buyer-reassignment.confirmation')}</Header>
      <ButtonsContainer>
        <RedButton onClick={onCanceled}>{t('common:cancel')}</RedButton>
        <RedButton onClick={onConfirmed}>{t('common:confirm')}</RedButton>
      </ButtonsContainer>
    </Container>
  );
};

export default ButtonsSection;
